import { useEffect, useState } from "react"
import { getBmdYearLevels } from "../services/bmd.service"
import type { BmdYearLevel } from "../types/bmd.types"

export type UseBmdYearLevelsState = {
  yearLevels: BmdYearLevel[]
  loading: boolean
  error: string | null
}

export function useBmdYearLevels(
  subjectId: number,
  studentKey: string,
): UseBmdYearLevelsState {
  const [yearLevels, setYearLevels] = useState<BmdYearLevel[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!subjectId || !studentKey) {
      setYearLevels([])
      setLoading(false)
      setError(null)
      return
    }

    const controller = new AbortController()
    setLoading(true)
    setError(null)

    getBmdYearLevels(
      { subject_id: subjectId, student_key: studentKey },
      controller.signal,
    )
      .then((res) => {
        setYearLevels(res.year_levels)
        setLoading(false)
      })
      .catch((err) => {
        if (controller.signal.aborted) return
        setError(err?.message || "Failed to load year levels")
        setYearLevels([])
        setLoading(false)
      })

    return () => {
      controller.abort()
    }
  }, [subjectId, studentKey])

  return { yearLevels, loading, error }
}
